﻿import "./Legacy/avatar-customization.js";
import "./swipe.ts";
import "./analytics.ts";

export const onFeedbackSubmit = function () {
    const input: HTMLFormElement | null = document.documentElement.querySelector('#feedbackForm .location');
    if (input) {
        input.value = window.location.pathname;
    }
};

const form: HTMLFormElement | null = document.documentElement.querySelector('#feedbackForm');
if (form) form.onsubmit = onFeedbackSubmit;


